import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { FieldValueResultDto } from '../../../reports-module/_models/field-value-result-dto';
import { CashInvestmentResultDto } from './cash-investment-result-dto';
const ɵ0 = () => FieldValueResultDto, ɵ1 = () => CashInvestmentResultDto;
export class CashInvestmentReportResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], CashInvestmentReportResultDto.prototype, "reportParameters", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], CashInvestmentReportResultDto.prototype, "cashInvestments", void 0);
export { ɵ0, ɵ1 };
